import { pathJoin } from '../../../../routing/utils';

// Pure path map — no component imports, safe in the eager route-map graph.
// The route CONFIG (which imports the page components) stays in ./route-config
// and is only loaded with the lazy section shell.
export const createRoutesMap = (prefix: string) => ({
  contact: pathJoin(prefix)('contact').chain,
  invoices: pathJoin(prefix)('invoices').chain,
  feedback: pathJoin(prefix)('feedback').chain,
});
